import type { ReactNode } from "react";

type StatusPageProps = {
  /** 缺省状态插画（来自 @/assets/default-icons）。 */
  illustration: string;
  title: string;
  description: string;
  /** 可选操作区（按钮 / 链接）。 */
  actions?: ReactNode;
};

/** 整页居中的状态占位（404、无权限、加载失败等），配缺省插画。 */
export function StatusPage({ illustration, title, description, actions }: StatusPageProps) {
  return (
    <main className="grid h-full place-items-center bg-background p-8">
      <section className="flex max-w-md flex-col items-center text-center">
        <img alt="" className="h-40 w-auto" src={illustration} />
        <h1 className="mt-6 text-2xl font-semibold text-foreground">{title}</h1>
        <p className="mt-3 text-sm leading-6 text-muted-foreground">{description}</p>
        {actions ? <div className="mt-6 flex items-center gap-3">{actions}</div> : null}
      </section>
    </main>
  );
}
